var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{on:{"click":_setup.toggle}},[_c('span',{staticClass:"flex items-center"},[_vm._t("default"),_vm._v(" "),_c('UiIcon',{staticClass:"ml-2 transition",class:{ 'rotate-180': _setup.isOpen },attrs:{"icon":"chevronDown"}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }